import { useSelector } from 'react-redux';

import { RootState } from '../../Store';
import { FilterState } from '../../Store/Filter/state';

import { Filter } from '../../Enum/Filters';
import { arraysOfStringsAreDifferent } from '../../Helpers/Array';
import { arePeriodArraysEqual } from '../../Helpers/Interest/PeriodHelper';

const useFilterIsActual = (filters: Filter[]): boolean => {
    const { filterValues, filteredValues } = useSelector<RootState, FilterState>(state => state.filter);

    return filters.every(filter => {
        switch (filter) {
            case Filter.Labels:
            case Filter.NewsLabels:
            case Filter.MortgageProperties:
            case Filter.BridgingLoanLabels:
                if (arraysOfStringsAreDifferent(filterValues[filter], filteredValues[filter])) {
                    return false;
                }
                break;
            case Filter.FixedPeriods:
                if (!arePeriodArraysEqual(filterValues[filter], filteredValues[filter])) {
                    return false;
                }
                break;
            default:
                if (filterValues[filter] !== filteredValues[filter]) {
                    return false;
                }
                break;
        }

        return true;
    });
};

export default useFilterIsActual;
